import React from "react";

function Cookie() {
    (function (d, s, id) {
        var js,
            tjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://app.termly.io/embed-policy.min.js";
        tjs.parentNode.insertBefore(js, tjs);
    })(document, "script", "termly-jssdk");

    return (
        <div id="main" className="wrapper">
            <div className="inner">
                <header className="page-header">
                    <h1>Cookie Policy</h1>
                    <p className="doc-meta">Effective Date: September 16, 2026</p>
                </header>
                <p>
                        At <strong>Reliance Litigation LLC</strong> (“we,” “us,”
                        or “our”), we are committed to transparency and
                        protecting your privacy. This Cookie Policy explains how
                        we use cookies and similar technologies on our website
                        to provide lead generation and marketing services for
                        the legal industry.
                    </p>

                <section>
                    <h2>1. What Are Cookies and Similar Technologies?</h2>
                    <p>
                        Cookies are small text files placed on your device
                        (e.g., computer, smartphone, or tablet) when you visit a
                        website. They store information about your browsing
                        activity and help websites function effectively. Similar
                        technologies, such as pixels, web beacons, and tags, are
                        also used to track user behavior and deliver
                        personalized content.
                    </p>
                    <p>These technologies may be:</p>
                    <ol>
                        <li>
                            <strong>First-party cookies</strong>: Set by
                            Reliance Litigation LLC to manage website
                            functionality and user experience.
                        </li>
                        <li>
                            <strong>Third-party cookies</strong>: Set by
                            external services (e.g., advertising platforms) to
                            enable features like targeted advertising and
                            analytics.
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>2. Why Do We Use Cookies?</h2>
                    <p>
                        We use cookies and similar technologies for the
                        following purposes:
                    </p>
                    <ol>
                        <li>
                            <strong>Essential Functionality</strong>: To ensure
                            our website operates correctly, such as enabling
                            secure browsing and maintaining user sessions.
                        </li>
                        <li>
                            <strong>Performance and Analytics</strong>: To
                            analyze how users interact with our website, track
                            website performance, and improve user experience.
                        </li>
                        <li>
                            <strong>Personalization</strong>: To remember your
                            preferences (e.g., language settings) and provide a
                            tailored browsing experience.
                        </li>
                        <li>
                            <strong>Marketing and Advertising</strong>: To
                            deliver targeted advertisements through our
                            advertising partners and measure the effectiveness
                            of our marketing campaigns.
                        </li>
                        <li>
                            <strong>Lead Generation</strong>: To identify
                            potential clients for legal services and connect
                            them with law firms through our lead generation
                            services.
                        </li>
                    </ol>
                </section>

                <section>
                    <h2>3. Types of Cookies We Use</h2>
                    <p>
                        We categorize cookies based on their purpose and
                        functionality. Below are the types of cookies used on
                        our website:
                    </p>

                    <div>
                        <h3>a. Essential Cookies</h3>
                        <p>
                            These cookies are necessary for the basic
                            functionality of our website. They do not collect
                            personal data and are automatically placed when you
                            visit our site. Examples include:
                        </p>
                        <ol>
                            <li>
                                Maintaining user sessions for secure browsing.
                            </li>
                            <li>
                                Enabling navigation between pages without losing
                                data.
                            </li>
                        </ol>
                    </div>

                    <div>
                        <h3>b. Performance and Analytics Cookies</h3>
                        <p>
                            These cookies help us understand how users interact
                            with our website without identifying individual
                            visitors. They collect data such as:
                        </p>
                        <ol>
                            <li>
                                Page views and time spent on specific pages.
                            </li>
                            <li>Bounce rates and user behavior trends.</li>
                        </ol>
                        <p>
                            We use tools like <strong>Google Analytics</strong>{" "}
                            to analyze this data and optimize our website’s
                            performance.
                        </p>
                    </div>

                    <div>
                        <h3>c. Functionality Cookies</h3>
                        <p>
                            These cookies remember your preferences to provide a
                            personalized experience. Examples include:
                        </p>
                        <ol>
                            <li>Saving language or location preferences.</li>
                            <li>
                                Storing login details for returning visitors (if
                                applicable).
                            </li>
                        </ol>
                    </div>

                    <div>
                        <h3>d. Marketing and Advertising Cookies</h3>
                        <p>
                            These cookies are used to deliver personalized
                            advertisements and track the effectiveness of our
                            marketing campaigns. They are often set by
                            third-party advertising platforms, including:
                        </p>
                        <ol>
                            <li>
                                <strong>Google Ads</strong>: Tracks ad clicks
                                and conversions to optimize ad delivery.
                            </li>
                            <li>
                                <strong>
                                    Meta Pixel (Facebook and Instagram)
                                </strong>
                                : Collects event data (e.g., page visits, form
                                submissions) to target ads and measure campaign
                                performance.
                            </li>
                            <li>
                                <strong>Microsoft Advertising (Bing)</strong>:
                                Tracks user behavior for advertising purposes,
                                including ad clicks and conversions.
                            </li>
                            <li>
                                <strong>LinkedIn Insight Tag</strong>: Places
                                cookies to track conversions and user
                                interactions after clicking LinkedIn ads.
                            </li>
                            <li>
                                <strong>Twitter (X) Ads</strong>: Tracks ad
                                engagement and user behavior for targeted
                                advertising.
                            </li>
                        </ol>
                        <p>
                            These cookies may collect data such as IP addresses,
                            timestamps, and browsing history to deliver relevant
                            ads.
                        </p>
                    </div>

                    <div>
                        <h3>e. Web Beacons and Pixels</h3>
                        <p>
                            We use web beacons and pixels (e.g., Meta Pixel,
                            LinkedIn Insight Tag) to track user activity and
                            measure the success of marketing campaigns. These
                            technologies work alongside cookies to monitor
                            traffic patterns, ad performance, and user
                            engagement.
                        </p>
                    </div>
                </section>

                <section>
                    <h2>4. Third-Party Cookies and Advertising Platforms</h2>
                    <p>
                        Our website integrates with third-party advertising
                        platforms to deliver targeted marketing and lead
                        generation services. These platforms set their own
                        cookies and may process personal data independently.
                        Below is an overview of the advertising channels we use
                        and their cookie practices:
                    </p>
                    <ol>
                        <li>
                            <strong>Google</strong>: Uses cookies for Google Ads
                            and Google Analytics to track ad performance, user
                            behavior, and website analytics. For more details,
                            refer to Google’s Privacy Policy.
                        </li>
                        <li>
                            <strong>Meta (Facebook and Instagram)</strong>: Uses
                            Meta Pixel to collect event data for targeted
                            advertising. Event data may include IP addresses,
                            page visits, and form submissions. For more details,
                            refer to Meta’s Privacy Policy.
                        </li>
                        <li>
                            <strong>Microsoft Advertising (Bing)</strong>: Uses
                            cookies to track ad clicks, conversions, and user
                            behavior for advertising purposes. For more details,
                            refer to Microsoft’s Privacy Policy.
                        </li>
                        <li>
                            <strong>LinkedIn</strong>: Uses the LinkedIn Insight
                            Tag to track conversions and user interactions with
                            LinkedIn ads. For more details, refer to LinkedIn’s
                            Cookie Policy.
                        </li>
                        <li>
                            <strong>Twitter (X)</strong>: Uses cookies to track
                            ad engagement and deliver personalized ads. For more
                            details, refer to Twitter’s Privacy Policy.
                        </li>
                    </ol>
                    <p>
                        We recommend reviewing the privacy policies of these
                        platforms for information on how they process personal
                        data and how you can exercise your rights.
                    </p>
                </section>

                <section>
                    <h2>5. Legal Basis for Cookie Use</h2>
                    <p>We use cookies based on the following legal grounds:</p>
                    <ol>
                        <li>
                            <strong>Consent</strong>: For non-essential cookies
                            (e.g., marketing and analytics cookies), you can
                            provide, manage, or withdraw your consent at any
                            time through your browser settings and the opt-out
                            tools described in Section 7 (How to Control
                            Cookies).
                        </li>
                        <li>
                            <strong>Legitimate Interest</strong>: For essential
                            cookies, we rely on our legitimate interest in
                            ensuring the proper functioning of our website and
                            delivering our services.
                        </li>
                    </ol>
                    <p>
                        We comply with applicable privacy laws, including the{" "}
                        <strong>California Consumer Privacy Act (CCPA)</strong>,{" "}
                        <strong>
                            General Data Protection Regulation (GDPR)
                        </strong>
                        , and other regional regulations, depending on your
                        location.
                    </p>
                </section>

                <section>
                    <h2>6. How We Manage Cookie Consent</h2>
                    <p>
                        You can control and manage cookies at any time through
                        your browser settings and the opt-out tools described in
                        Section 7 below. Most browsers allow you to accept,
                        block, or delete cookies, and to be notified when a
                        cookie is set. Note that blocking or rejecting cookies
                        may affect the functionality and relevance of content on
                        our website.
                    </p>
                </section>

                <section>
                    <h2>7. How to Control Cookies</h2>
                    <p>
                        You can manage cookies through your browser settings or
                        our cookie consent tool. Most browsers allow you to:
                    </p>
                    <ol>
                        <li>Block all cookies.</li>
                        <li>Delete existing cookies.</li>
                        <li>Receive notifications when cookies are set.</li>
                    </ol>
                    <p>
                        To manage cookies in your browser, follow the
                        instructions provided by your browser manufacturer:
                    </p>
                    <ol>
                        <li>Google Chrome</li>
                        <li>Mozilla Firefox</li>
                        <li>Microsoft Edge</li>
                        <li>Safari</li>
                        <li>Opera</li>
                    </ol>
                    <p>
                        For third-party cookies (e.g., advertising cookies), you
                        can opt out of targeted advertising through the
                        following tools:
                    </p>
                    <ol>
                        <li>Google Ads Settings</li>
                        <li>Meta Ad Preferences</li>
                        <li>Microsoft Advertising Opt-Out</li>
                        <li>LinkedIn Ad Preferences</li>
                        <li>Twitter (X) Ad Preferences</li>
                    </ol>
                    <p>
                        You can also use browser add-ons like the{" "}
                        <strong>Google Analytics Opt-Out Add-on</strong> to
                        disable specific analytics cookies.
                    </p>
                </section>

                <section>
                    <h2>8. Data Processing and Sharing</h2>
                    <p>
                        Cookies may collect personal data, such as IP addresses,
                        browsing history, and device information. This data may
                        be processed by:
                    </p>
                    <ol>
                        <li>
                            <strong>Reliance Litigation LLC</strong>: As the
                            data controller, we process cookie data to deliver
                            our services and improve our website.
                        </li>
                        <li>
                            <strong>Third-Party Processors</strong>: Advertising
                            platforms (Google, Meta, Microsoft, LinkedIn,
                            Twitter) process cookie data on our behalf to
                            deliver targeted ads and analytics. These platforms
                            act as joint controllers or independent controllers
                            for subsequent data processing.
                        </li>
                    </ol>
                    <p>
                        We do not sell personal data collected through cookies.
                        However, third-party advertising platforms may use
                        cookie data for their own purposes, as outlined in their
                        privacy policies.
                    </p>
                </section>

                <section>
                    <h2>9. Updates to This Cookie Policy</h2>
                    <p>
                        We regularly review and update this Cookie Policy to
                        reflect changes in legal requirements, technology, and
                        our services. Any updates will be posted on this page,
                        and significant changes will be communicated through a
                        prominent announcement on our website or via email.
                    </p>
                    <p>
                        We encourage you to review this policy periodically to
                        stay informed about how we use cookies.
                    </p>
                </section>

                <section>
                    <h2>10. Contact Us</h2>
                    <p>
                        If you have questions about this Cookie Policy or our
                        use of cookies, please contact us at:
                    </p>
                    <p>
                        <strong>Reliance Litigation LLC</strong>
                        <br />
                        21550 Oxnard St, FL 3
                        <br />
                        Woodland Hills, CA 91367
                        <br />
                        Email: privacy@reliancelitigation.com
                        <br />
                        Phone: (888) 856-7299
                    </p>
                    <p>
                        For general inquiries about data protection, you can
                        also reach us using the contact details provided on our
                        website.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default Cookie;
